module.exports = __webpack_public_path__ + "img/loading1.5e93729e.gif";